<template>
  <div class="container-register-kit">
    <h4 v-if="step == 1">Pronto! <br>Vamos iniciar com o preenchimento do formulário para conseguirmos entregar muito mais do que simples resultados!</h4>
    <p v-if="step == 1">Preencha os campos a seguir, pois para cruzar os resultados de seus exames com nossos algoritmos médicos, precisamos conhecer mais sobre sua saúde e hábitos de vida! 
    <span class="bold">É rápido, seguro e você já começa a ter mais saúde.</span></p>
	  <div v-if="step == 1" class="split"></div>
    <form-steps :kit_type="kit_type" v-if="kit_type" @formNextStep="formNextStep" @send="sendAnswers" @setFormSteps="setFormSteps"/>
  </div>
</template>

<script>
    import {POST_KIT_VALIDATE} from "../../services/kit";
    import {POST_FORM} from "../../services/form";

    import FormSteps from '../FormSteps/FormSteps';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';
    import moment from 'moment';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'

    moment().format();

    library.add(faCheckCircle);

    export default {
        components: {DatePicker, FormSteps},
        props: ['next', 'kit', 'kit_id', 'kit_type', 'step'],
        name: "DataKitHealthCustomer",
        data: () => ({
            urlKey: 'https://ipgeolocation.abstractapi.com/v1/?api_key=4e6fee071709484e9b7deb66863896a9',
            loading: false,
            errors: [],
            form: {
                kit_number: null,
                digi_sig: {
                    date: null,
                    data: null,
                },
                birth_date: null,
                height: null,
                weight: null,
                diseases: null,
                had_covid: null,
                diagnosis_date: null,
                evolution: null,
                symptoms: {
                    fadiga: false,
                    dor_cronica: false,
                    fraqueza_muscular: false,
                    dificuldade_respirar: false,
                    deficits_cognitivos: false,
                    febre_alta: false,
                    manchas_pele: false,
                    indisposicao: false,
                },
                vaccine: '',
                first_shot: null,
                second_shot: null,
                accept_terms: false,
            }
        }),
        mounted() {
          this.form.kit_number = this.kit;
        },
        methods: {
            ipGet(url) {
                let ret = null;
                const xmlHttp = new XMLHttpRequest();
                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState === 4 && xmlHttp.status === 200)
                        ret = xmlHttp.responseText;
                };
                xmlHttp.open("GET", url, false);
                xmlHttp.send(null);
                return ret;
            },
            clearErrors() {
                this.errors = [];
            },
            switchHadCovid(value) {
                this.form.had_covid = value;
            },
            onlyNumbers(evt) {
              evt = (evt) ? evt : window.event;
              let charCode = (evt.which) ? evt.which : evt.keyCode;
              if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
              } else {
                return true;
              }
            },
            setFormSteps(steps) {
              this.$emit('setFormSteps', steps); 
            },
            formNextStep(to = true) {
              this.$emit('formNextStep', to);
            },
            sendAnswers(answers) {
              POST_FORM(this.kit_id, answers)
                .then(
                  resp => {
                    this.$emit('next', this.form);
                  }
                )
            },
            handleSubmit(event) {
                event.preventDefault();
                this.clearErrors();
                if (this.form.accept_terms !== 1 && this.form.accept_terms !== true) {
                    this.errors.accept_terms = ["Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?"];
                    return false;
                }
                this.loading = true;

                this.form.digi_sig.date = moment().format('YYYY-MM-DD hh:mm:ss');
                this.form.digi_sig.data = this.ipGet(this.urlKey);

                POST_KIT_VALIDATE(this.form).then(
                    resp => {
                        this.$emit('next', this.form);
                    },
                    error => this.errors = error.response.data,
                ).then(
                    resp => {
                        this.loading = false;
                    }
                );
            }
        }
    }
</script>

<style scoped>
	.container-register-kit {
		max-width: 540px;
		margin: 0 auto;
	}

	.checkbox-text {
		display: flex;
		justify-content: flex-start;
	}

	.checkbox-text input[type="checkbox"] {
		width: initial;
		min-width: 20px;
		height: 22px;
		margin-right: 10px;
	}

	.checkbox-text p {
		font-weight: bold;
	}

	.bold {
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/DataKitHealthCustomer.vue